/**
 * Discrete gradient scrim painted behind the fixed prompt bar / mission chips so they stay
 * legible over arbitrary scrolling content. Sits at the viewport bottom, below the bar
 * (z-20 < the bar's z-30), and is non-interactive.
 *
 * The veil contrasts with the chips in each theme so they pop in both:
 * - light: a soft dark veil (white chips read against it),
 * - dark:  a soft light lift (dark `#1E2022` chips read against it).
 */
interface PromptBarScrimProps {
  /** Tailwind height class. Default h-32 fits the full prompt bar; use a shorter one for the
   * chips-only surface (no textfield) where h-32 reads as broken empty padding. */
  heightClassName?: string;
}

export const PromptBarScrim = ({ heightClassName = 'h-32' }: PromptBarScrimProps = {}) => (
  <div
    aria-hidden
    className={`pointer-events-none fixed inset-x-0 bottom-0 z-20 ${heightClassName} bg-linear-to-t from-black/30 via-black/15 to-transparent dark:from-white/25 dark:via-white/10`}
  />
);
